import { ContainerController } from './container.controller';
import { ContainerComponentProps } from './container.model';

const Container = (props: ContainerComponentProps): JSX.Element => {
  return <ContainerController {...props} />;
};
export default Container;
